import Requisicao from "./RequisicaoService";

class EmailService {
    static async gravar(idCliente, email) {
        return Requisicao.post('email', {
            idCliente: idCliente,
            email: email
        });
    }
}

export default EmailService;